import React from 'react';
import styled from 'styled-components';
import { RankPageViewCount } from '../../../api/serviceAnalytics/pageviewAnalysis/type';
import Header from '../../Molecule/Card/CardHeader';
import Title from '../../Molecule/Card/CardTitle/ChartTitle';
import Spinner from '../../Molecule/Spinner';
import PageViewTable from '../Table/PageViewTable';

const Component = styled.div`
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 24px 24px 40px 24px;
  border-radius: 16px;
`;

const Body = styled.div`
  flex: 1;
  width: 100%;
  margin-top: 40px;
`;

interface PageViewTableCardProps {
  Data: RankPageViewCount[] | null;
  loading: boolean;
}

const PageViewTableCard = ({ Data, loading }: PageViewTableCardProps) => {
  return (
    <Component>
      <Header>
        <Title title="URL별 페이지뷰 수" />
      </Header>
      <Body>
        {loading ? (
          <Spinner />
        ) : (
          <PageViewTable Data={Data} loading={loading} />
        )}
      </Body>
    </Component>
  );
};

export default PageViewTableCard;
